import { render, staticRenderFns } from "./downSAP.vue?vue&type=template&id=0ad65dab&scoped=true&"
import script from "./downSAP.vue?vue&type=script&lang=js&"
export * from "./downSAP.vue?vue&type=script&lang=js&"
import style0 from "./downSAP.vue?vue&type=style&index=0&id=0ad65dab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad65dab",
  null
  
)

export default component.exports